import { ChangeDetectorRef, Component, Inject, model, OnInit, PLATFORM_ID, TemplateRef, ViewChild } from '@angular/core';
import { Database, Script, ScriptName, viewFile, viewMetaData } from '../../../models/database';
import { DatabaseService } from '../../services/database/database.service';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FileViewComponentComponent } from '../../shared/file-view-component/file-view-component.component';
import { DomSanitizer, SafeHtml, SafeResourceUrl } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { catchError, finalize, of } from 'rxjs';
import { ScriptViewComponentComponent } from '../../shared/script-view-component/script-view-component.component';
import { LoadingServiceService } from '../../services/loadingService/loading-service.service';
import { MSAL_GUARD_CONFIG, MsalGuardConfiguration } from '@azure/msal-angular';


@Component({
  selector: 'app-available-scripts',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormsModule],
  templateUrl: './available-scripts.component.html',
  styleUrl: './available-scripts.component.scss'
})
export class AvailableScriptsComponent implements OnInit {

  @ViewChild('contentModal', { static: false }) contentModal!: TemplateRef<any>

  databases: Database[] = [];
  scripts: Script[] = []
  searchFile = '';
  scriptContent: viewFile | null = null;
  errorMessage: string | null = null
  filteredScripts: Script[] = []
  pagedScripts: Script[] = []
  pageSize = 10;
  currentPage = 1;
  totalScripts = 0;
  totalPages = 1;
  pages: number[] = []

  constructor(
    private databaseService: DatabaseService,
    private modalService: NgbModal,
    private sanitizer: DomSanitizer,
    private cdRef: ChangeDetectorRef,
    public loadService: LoadingServiceService,
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) { }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.loadService.show();
      this.loadScripts()
    }
  }

  loadScripts() {
    const params = {
      sort_by: 'date',
      // limit: 15
    }
    //const sessionID = sessionStorage.getItem('Session_Id')
    this.databaseService.getScriptNames(params).pipe(
      finalize(() => this.loadService.hide())
    ).subscribe((data: ScriptName) => {
      if (data && data.scripts) {
        this.scripts = data.scripts
        this.filteredScript();
      } else {
        console.error("Check for API Breakpoints")
      }
    })
  }

  onSearchChange(event: Event) {
    this.currentPage = 1;
    this.filteredScript();
    // this.searchFile = (event.target as HTMLInputElement).value.toLowerCase();
  }

  filteredScript() {
    if (!this.searchFile) {
      this.filteredScripts = [...this.scripts]
    } else {
      this.filteredScripts = this.scripts.filter(script => script.name.toLowerCase().includes(this.searchFile))
    }

    this.totalScripts = this.filteredScripts.length;
    this.calculateTotalPages();
    this.currentPage = 1;
    this.pageChanged();
    // return this.scripts.filter(script => script.filename.toLowerCase().includes(this.searchFile))
  }


  viewFile(script_name: string, fileType: 'script' | 'validation') {
    this.loadService.show()
    //const sessionID = sessionStorage.getItem('Session_Id')
    this.databaseService.getScriptContent(script_name, fileType).pipe(
      finalize(() => this.loadService.hide()),
      catchError(error => {
        // console.error(`Error Viewing Script ${filename}:`, error)
        this.errorMessage = "Error Loading Script Content"
        return of(null)
      })
    ).subscribe((content: viewFile | null) => {

      if (content) {
        const modalRef = this.modalService.open(ScriptViewComponentComponent, {
          size: 'xl',
          backdrop: 'static',
          keyboard: false
        });
        modalRef.componentInstance.heading = `${content.script_name}`;
        modalRef.componentInstance.message = fileType === 'script' ? content.script_content.trim() : content.validation_content.trim()
        modalRef.componentInstance.fileType = this.getFileType(content.script_name)
      }
      else {
        this.errorMessage = 'Error While loading the Script'
      }
    })
  }

  viewMetadataFile(script_path: string) {
    this.loadService.show()
    //const sessionID = sessionStorage.getItem('Session_Id')
    this.databaseService.getMetadataContent(script_path).pipe(
      finalize(() => this.loadService.hide()),
      catchError(error => {
        // console.error(`Error Viewing Script ${filename}:`, error)
        this.errorMessage = "Error Loading Script Content"
        return of(null)
      })
    ).subscribe((content: viewMetaData | null) => {

      if (content) {
        const modalRef = this.modalService.open(ScriptViewComponentComponent, {
          size: 'xl',
          backdrop: 'static',
          keyboard: false
        });
        modalRef.componentInstance.heading = `${content.metadata_filename}`;
        modalRef.componentInstance.message = JSON.stringify(content.metadata_content.content, null, 2);
        modalRef.componentInstance.fileType = 'json'
      }
      else {
        this.errorMessage = 'Error While loading the Script'
      }
    })
  }

  getFileType(filename: string): 'python' | 'json' | 'text' {
    if (filename.endsWith('.py')) {
      return 'python';
    } else if (filename.endsWith('.json')) {
      return 'json';
    } else {
      return 'text';
    }
  }

  pageChanged() {
    const startIndex = (this.currentPage - 1) * this.pageSize;
    const endIndex = Math.min(startIndex + this.pageSize, this.totalScripts); // Prevent going beyond the last index

    if (this.filteredScripts && this.filteredScripts.length > 0) {
      this.pagedScripts = this.filteredScripts.slice(startIndex, endIndex);
    } else {
      this.pagedScripts = []
    }

  }

  calculateTotalPages() {
    this.totalPages = Math.ceil(this.totalScripts / this.pageSize)
    this.pages = [];
    for (let i = 1; i <= this.totalPages; i++) {
      this.pages.push(i)
    }
  }

  previousPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.pageChanged()
    }
  }

  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.pageChanged();
    }
  }

  goToPage(page: number) {
    this.currentPage = page;
    this.pageChanged();
  }
}
